package fr.frux.shared.data.mapper

import fr.frux.shared.domain.model.PlantingCount
import fr.frux.shared.domain.model.PlantingDraft
import fr.frux.shared.domain.model.Site
import fr.frux.shared.domain.model.SiteAccessRule
import fr.frux.shared.domain.model.SiteDraft
import fr.frux.shared.domain.model.SiteHarvestSummary
import fr.frux.shared.domain.model.SitePlanting
import fr.frux.shared.dto.CreatePlantingRequest
import fr.frux.shared.dto.CreateSiteRequest
import fr.frux.shared.dto.PlantingCountDto
import fr.frux.shared.dto.SiteAccessRuleDto
import fr.frux.shared.dto.SiteDto
import fr.frux.shared.dto.SiteHarvestSummaryDto
import fr.frux.shared.dto.SitePlantingDto

fun SiteDto.toDomain(): Site =
    Site(
        id = id,
        name = name,
        description = description,
        latitude = latitude,
        longitude = longitude,
        accessRule = accessRule.toDomain(),
        managerName = managerName,
        hasOwner = ownerUserId != null,
        plantings = plantings.map { it.toDomain() },
        treesCount = treesCount,
        trees = trees?.map { it.toDomain() }.orEmpty(),
        createdBy = createdBy,
        createdByUsername = createdByUsername,
        createdAtMillis = createdAt?.toEpochMilliseconds(),
        isFavorite = isFavorite,
        isOwner = isOwner,
        canDelete = canDelete,
        reportedByMe = reportedByMe,
        nextHarvest = nextHarvest?.toDomain(),
        canClaim = canClaim,
    )

fun SiteHarvestSummaryDto.toDomain(): SiteHarvestSummary =
    SiteHarvestSummary(
        id = id,
        scheduledAtMillis = scheduledDate.toEpochMilliseconds(),
        status = status.toDomain(),
        hostedByOwner = hostedByOwner,
    )

fun SitePlantingDto.toDomain(): SitePlanting =
    SitePlanting(id = id, species = species.toDomain(), count = countEstimate.toDomain(), note = note)

fun SiteAccessRuleDto.toDomain(): SiteAccessRule =
    when (this) {
        SiteAccessRuleDto.OPEN -> SiteAccessRule.OPEN
        SiteAccessRuleDto.ASK -> SiteAccessRule.ASK
        SiteAccessRuleDto.PRIVATE -> SiteAccessRule.PRIVATE
    }

fun SiteAccessRule.toDto(): SiteAccessRuleDto =
    when (this) {
        SiteAccessRule.OPEN -> SiteAccessRuleDto.OPEN
        SiteAccessRule.ASK -> SiteAccessRuleDto.ASK
        SiteAccessRule.PRIVATE -> SiteAccessRuleDto.PRIVATE
    }

fun PlantingCountDto.toDomain(): PlantingCount =
    when (this) {
        PlantingCountDto.ONE -> PlantingCount.ONE
        PlantingCountDto.FEW -> PlantingCount.FEW
        PlantingCountDto.SOME -> PlantingCount.SOME
        PlantingCountDto.MANY -> PlantingCount.MANY
    }

fun PlantingCount.toDto(): PlantingCountDto =
    when (this) {
        PlantingCount.ONE -> PlantingCountDto.ONE
        PlantingCount.FEW -> PlantingCountDto.FEW
        PlantingCount.SOME -> PlantingCountDto.SOME
        PlantingCount.MANY -> PlantingCountDto.MANY
    }

fun PlantingDraft.toRequest(): CreatePlantingRequest =
    CreatePlantingRequest(speciesId = speciesId, countEstimate = count.toDto())

/** « Chez moi » force `PRIVATE` et la revendication : le serveur refuse toute autre combinaison. */
fun SiteDraft.toRequest(): CreateSiteRequest =
    CreateSiteRequest(
        name = name.trim(),
        latitude = latitude,
        longitude = longitude,
        accessRule = if (isHome) SiteAccessRuleDto.PRIVATE else accessRule.toDto(),
        managerName = managerName?.trim()?.takeIf { it.isNotEmpty() },
        claimOwnership = isHome,
        plantings = plantings.map { it.toRequest() },
    )
